<template>
    <div class="container">
        <h2 class="stockAlert">{{ $t('outOfStockAlerts') }}</h2>
        <table class="responsive-table">
            <thead>
                <tr>
                    <th scope="col">{{ $tc('product', 1) }} </th>
                    <th scope="col">{{ $tc('unit', 1) }}</th>
                    <!-- <th scope="col">{{ $t('stock') }}</th> -->
                    <th scope="col">{{ $t('lastInventoryCheck') }}</th>
                    <th scope="col"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(unitProduct, index) in lowStockList" :key="index" >
                    <th scope="row">{{ unitProduct.product_name }}</th>
                    <td :data-title="$tc('unit', 1)">{{ unitProduct.unit_name }}</td>
                    <!-- <td data-title="Stock">{{ unitProduct.stock_curr }}/{{ unitProduct.stock_max }}</td> -->
                    <td :data-title="$t('lastInventoryCheck')"> {{ unitProduct.last_updated_at | formatDate }} </td>
                    <td>
                        <div class="plusIcon" @click="$emit('change-stock', { unit_id: unitProduct.unit_id, product_id: unitProduct.product_id, stock_curr: unitProduct.stock_curr, stock_general: unitProduct.stock_general, stock_max: unitProduct.stock_max })">
                            <font-awesome-icon class="icon" icon="plus" />
                            <span>{{ $t('add') }}</span>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import moment from 'moment';

    export default {
      filters: {
        formatDate: function(value) {
          if (value) {
            return moment(String(value)).format("ddd, DD-MM-YYYY")
          }
        }
      },
      data() {
        return {
        }
      },
      props: {
        lowStockList: {
          type: Array,
          default: () => []
        }
      },
    }
</script>

<style lang="scss" scoped>

// Breakpoints
$bp-maggie: 15em; 
$bp-lisa: 30em;
$bp-bart: 48em;
$bp-marge: 62em;
$bp-homer: 90em;

// Styles
// * {
//   @include box-sizing(border-box);
  
//   &:before{
//     @include box-sizing(border-box);
//   }
//   &:after {
//     @include box-sizing(border-box);
//   }
// }

// body {
//   font-family: $helvetica;
//   color: rgba(94,93,82,1);
// }

a {
  color: var(--primary);
  
  &:hover,
  &:focus {
    color: var(--primary); 
  }
}

.about-img2 {
  display: inline-block;
  width: 100%;
  max-width: 500px;
  text-align: center;
  vertical-align: top;
}

.stockAlert {
  color: var(--bg);
  font-size: 1.5em;
  font-weight: 600;
  padding-bottom: 10px;
}

.metricsNo {
  font-size: 4em;
  font-weight: 800;
  padding-left: 2px;
  display: inline;
}
.metricsUnit {
  font-size: 1.5em;
}
.metricsInitals {
  font-weight: 400;
  font-size: 2.7em;
  padding-left: 0px;
  letter-spacing: 2px;
}
.metricsDesc {
  font-size: 1em;
}


.container {
  // margin: 5% 3%;
  
  @media (min-width: $bp-bart) {
    // margin: 2%; 
  }
  
  @media (min-width: $bp-homer) {
    // margin: 2em auto;
    // max-width: $bp-homer;
  }
}

.responsive-table {
  width: 100%;
  margin-bottom: 1.5em;
  border-spacing: 0;
  
  @media (min-width: $bp-bart) {
    font-size: .9em; 
  }
  
  @media (min-width: $bp-marge) {
    font-size: 1em; 
  }
  
  thead {
    // Accessibly hide <thead> on narrow viewports
    position: absolute;
    clip: rect(1px 1px 1px 1px); /* IE6, IE7 */
    padding: 0;
    border: 0;
    height: 1px; 
    width: 1px; 
    overflow: hidden;
    
    @media (min-width: $bp-bart) {
      // Unhide <thead> on wide viewports
      position: relative;
      clip: auto;
      height: auto;
      width: auto;
      overflow: auto;
    }
    
    th {
      background-color: var(--bg-light); 
      border: 1px solid var(--bg-light); 
      font-weight: normal;
      text-align: center;
      color: var(--bright); 
      font-size: 0.7em;

      &:first-of-type {
        text-align: left; 
      }
    }
  }

  .plusIcon {
  background: var(--bg-superLight); 
  color: var(--bright); 
  padding: 2px;
  letter-spacing: 1px;
  border: none;
  border-radius: 3.5px;
  width: auto;
  height: 30px;
  text-transform: uppercase;
  position: relative;
}

.icon {
  font-size: 1.3em;
  padding: 1px;
  margin-top: 5px;
}
  
  // Set these items to display: block for narrow viewports
  tbody,
  tr,
  th,
  td {
    display: block;
    padding: 0;
    text-align: left;
    white-space: normal;
  }
  
  tr {   
    @media (min-width: $bp-bart) {
      // Undo display: block 
      display: table-row; 
    }
  }
  
  th,
  td {
    padding: .5em;
    vertical-align: middle;
    font-size: 0.8em;

    
    @media (min-width: $bp-lisa) {
      padding: .75em .5em; 
    }
    
    @media (min-width: $bp-bart) {
      // Undo display: block 
      display: table-cell;
      padding: .5em;
    }
    
    @media (min-width: $bp-marge) {
      padding: .75em .5em; 
    }
    
    @media (min-width: $bp-homer) {
      padding: .75em; 
    }
  }
  
  caption {
    margin-bottom: 1em;
    font-size: 1em;
    font-weight: bold;
    text-align: center;
    
    @media (min-width: $bp-bart) {
      font-size: 1.5em;
    }
  }
  
  tfoot {
    font-size: .8em;
    font-style: italic;
    
    @media (min-width: $bp-marge) {
      font-size: .9em;
    }
  }
  
  tbody {
    @media (min-width: $bp-bart) {
      // Undo display: block 
      display: table-row-group; 
    }
    
    tr {
      margin-bottom: 1em;
      
      @media (min-width: $bp-bart) {
        // Undo display: block 
        display: table-row;
        border-width: 1px;
      }
      
      &:last-of-type {
        margin-bottom: 0; 
      }
      
      &:nth-of-type(even) {
        @media (min-width: $bp-bart) {
          background-color: rgba(94,93,82,.1);
        }
      }
    }
    
    th[scope="row"] {
      background-color: var(--bg-light);
      color: white;
      
      @media (min-width: $bp-lisa) {
        border-left: 1px solid  var(--bg-light);
        border-bottom: 1px solid var(--bg-light);
      }
      
      @media (min-width: $bp-bart) {
        background-color: transparent;
        color: rgba(94,93,82,1);
        text-align: left;
      }
    }
    
    td {
      text-align: right;
      
      @media (min-width: $bp-bart) {
        border-left: 1px solid var(--bg-light);
        border-bottom: 1px solid var(--bg-light);
        text-align: center; 
      }
      
      &:last-of-type {
        @media (min-width: $bp-bart) {
          border-right: 1px solid var(--bg-light);
        } 
      }
    }
    
    td[data-type=currency] {
      text-align: right; 
    }
    
    td[data-title]:before {
      content: attr(data-title);
      float: left;
      font-size: .8em;
      color: rgba(94,93,82,.75);
      
      @media (min-width: $bp-lisa) {
        font-size: .9em; 
      }
      
      @media (min-width: $bp-bart) {
        // Don’t show data-title labels 
        content: none; 
      }
    } 
  }
}

  @media (min-width: 750px) {
    .plusIcon span {
      display: none;
    }
      }
  @media (max-width: 750px) {
    .plusIcon {
      width: 100px !important;
      text-align: center;
    }
    .plusIcon span {
      margin-left: 3px;    
    }
      }
</style>